import React, { useEffect, useMemo, useState } from 'react';
import {EuiFlexGroup, EuiFlexItem, EuiPanel, EuiSelect} from '@elastic/eui';
import { SidebarFacturacionExpatriados } from './sidebar';
import { PanelDetalleFacturacionExpatriados } from './detalle';
import { useUserSettings } from '../../../context/CurrentUserContext';
import { PERFIL_ADMIN } from '../../../../../shared/constanst/constants';
//import { useProfile } from '../../../../../shared/hooks/Profile';

// export interface FilterStruct{
//     sociedad:any,
//     dn:any,
//     grupoFactura:any,
//     usuario:any
//     activo: 'sociedad' | 'dn' | 'grupoFactura' | 'usuario'
// }

export interface FilterStruct{
    tipo: 'sociedad' | 'dn' | 'grupoFactura' | 'usuario',
    selection: any
}

export interface FilterProps{
    filter:FilterStruct,
    setFilter(newFilter:FilterStruct):any
}

const defaultFilter:FilterStruct = {tipo:'sociedad', selection:undefined}

export const FacturacionExpatriadosScreen = (props:any)=>{

    const {currentUser}:any = useUserSettings()
    const {translate} = props;

    const [filter, setFilter] = useState(defaultFilter);
    //const [estadoUsers, setEstadoUsers] = useState(undefined);
    
    const filterConfig:FilterProps = useMemo(()=>{return {filter:filter,setFilter:setFilter}},[filter])

    const haveSelected = useMemo(()=> filter.selection!==undefined,[filter])

    const AdministraExpatriados = useMemo(()=>(currentUser.administraExpatriados || currentUser.perfil === PERFIL_ADMIN),[currentUser,PERFIL_ADMIN])

    return (
        <EuiFlexGroup direction='column' style={{height:'100%'}} gutterSize='none'>
            <EuiFlexItem style={{height:'100%'}}>
                <EuiFlexGroup style={{height:'100%'}} gutterSize='none'>
                    <EuiFlexItem grow={3} style={{overflow:'hidden'}}>
                        <EuiPanel style={{overflow:'hidden',borderTopRightRadius:'0px',borderBottomRightRadius:'0px'}}>
                        <EuiFlexGroup direction='column' style={{height:'100%'}}>
                            <SidebarFacturacionExpatriados filterConfig={filterConfig}
                            translate={translate} admExpatriados={AdministraExpatriados}/>
                        </EuiFlexGroup>
                        </EuiPanel>
                    </EuiFlexItem> 
                    <EuiFlexItem grow={7}>
                        <PanelDetalleFacturacionExpatriados filterConfig={filterConfig} visible={haveSelected} 
                        user={currentUser} translate={translate}/>
                    </EuiFlexItem>
                </EuiFlexGroup>
            </EuiFlexItem>  
        </EuiFlexGroup> 
    )
}